module.exports = __webpack_public_path__ + "fonts/Lato-Light.4ac54dd4.woff";